import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  addonWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '15px 25px',
    background: '#fff',
    borderLeft: `5px solid ${theme.custom.darkBlue}`,
    boxShadow: '0px 5px 8px rgba(112, 136, 210, .34)',
    [theme.breakpoints.down(theme.size.sm)]: {
      padding: 10,
    },
  },
  addonTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 45,
    padding: '10px 20px',
    background: theme.custom.darkBlue,
  },
  addonTitle: {
    margin: 0,
    padding: 0,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    textAlign: 'center',
  },
  btn: {
    minWidth: 'auto',
    padding: 2,
    background: '#F0F3F7',
    borderRadius: '50%',
    '&:hover svg': {
      color: '#fff',
    },
  },
  icon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
}));
